export default function registerOpenHandler(viewer: any){
    viewer.addHandler('open', function (event: any) {
        // Assuming the overlay is the second item added (index 1)
        if (viewer.world.getItemCount() === 2) {
            const overlay = viewer.world.getItemAt(1);
            overlay.setOpacity(0.2);
        }
    });
}